export class ProdutoVariacaoValorStruct {
  idVariacao: number = 0;
  listVariacaoValor: VariacaoValorStruct[] = [];
}

export class VariacaoValorStruct {
  idVariacaoValor: number | null = null;
  valor: string = '';
}